import { Component, Input, OnChanges, OnInit, OnDestroy, SimpleChanges } from '@angular/core';
import { ListaPlikow, Plik } from 'src/app/modul-mapowy/mm-core/providers/multimedia-i-zalaczniki-adapter';
import { Warstwa } from '../../../modele/warstwa';
import { InformacjeOObiekcie } from '../../../utils/obiekty-mapy-utils';
import { SekcjeOkna } from '../informacje-o-obiekcie/informacje-o-obiekcie.component';
import { ControllerMultimediaOpenService } from 'src/app/core/api/controller-multimedia-open.service';
import { environment } from 'src/environments/environment';
import { HttpUrlEncodingCodec } from '@angular/common/http';
import { ControllerMapyService } from 'src/app/core/api/controller-mapy.service';
import { Mapa, ZalacznikiOpisyDane } from '../../../modele/mapa';
import { map, of, Subject, switchMap, takeUntil } from 'rxjs';

interface ElementKaruzeli {
  index: number;
  plik: Plik;
}

@Component({
  selector: 'mm-obiekt-zalaczniki-i-zdjecia',
  templateUrl: './obiekt-zalaczniki-i-zdjecia.component.html',
  styleUrls: ['./obiekt-zalaczniki-i-zdjecia.component.scss'],
})
export class ObiektZalacznikiIZdjeciaComponent implements OnInit, OnChanges, OnDestroy {

  @Input() warstwa?: Warstwa;
  @Input() obiekt?: InformacjeOObiekcie;
  @Input() sekcjeOkna?: SekcjeOkna;
  @Input() mapa?: Mapa;
  show: boolean = false;
  multimedia?: ListaPlikow;
  zalacznikiOpisy?: ZalacznikiOpisyDane[];
  zalaczniki?: ListaPlikow;
  obrazkiIWideo: ListaPlikow = { pliki: [] };
  dzwieki: ListaPlikow = { pliki: [] };

  wybraneZdjecieIndeks = 0;
  wybraneZdjecie?: Plik;

  wybraneAudioIndeks = 0;
  wybraneAudio?: Plik;

  widocznaGaleriaPelnoekranowa = false;

  plikiWKaruzeli?: ElementKaruzeli[];
  plikiWKaruzeliObrazkiIWideo?: ElementKaruzeli[];
  plikiWKaruzeliAudio?: ElementKaruzeli[];
  url: string = environment.baseUrl;
  private destroy$ = new Subject<void>();
  /**
   * Konstruktor
   * @param multimediaIZalaczniki
   */
  constructor(
    private multimediaIZalaczniki:
      ControllerMultimediaOpenService,
    private serwisMapy: ControllerMapyService,
  ) {
  }

  /**
   * Cykl życia komponentu inicjalizacja
   */
  ngOnInit(): void {
    this.zaladujPliki();
  }

  /**
   * Cykl życia komponentu niszczenie
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges): void {
    this.wyczyscDane();
    this.zaladujPliki();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Funkcja pobiera załączniki i multimedia
   */
  zaladujPliki(): void {
    if (!this.warstwa || !this.obiekt || !this.sekcjeOkna?.galeria.widoczna) {
      return;
    }

    const { szczegolyWarstwy } = this.warstwa;

    this.multimediaIZalaczniki
      .pobierzListePlikowPoZrodleDanychIMVC(
        szczegolyWarstwy?.zrodloMVC as string,
        szczegolyWarstwy?.nazwaMVC as string,
        +this.obiekt.id
      )
      .pipe(
        takeUntil(this.destroy$),

        switchMap((result) => {
          const pliki = (result.content ?? []) as Plik[];

          if (!this.mapa?.zalaczniki) {
            return of({ pliki });
          }

          const z = this.mapa.zalaczniki;

          return this.serwisMapy
            .getZalacznikOpisy(
              z.schemat!,
              z.tabela!,
              z.idObiektuKolumna!,
              z.opisKolumna!,
              z.opisAltKolumna!,
              z.nazwaPlikuKolumna!,
              this.obiekt!.id!
            )
            .pipe(
              map((opisy) => ({
                pliki: this.polaczPlikiZOpisami(pliki, opisy),
              }))
            );
        })
      )
      .subscribe(({ pliki }) => {
        this.multimedia = { pliki };
        this.inicjujGalerie();
        this.show = true;
      });
  }
  private polaczPlikiZOpisami(pliki: Plik[], opisy: any[]): Plik[] {
    const mapOpisow = new Map(
      opisy.map((o) => [o.nazwaPliku, o])
    );

    return pliki.map((plik) => {
      const opis = mapOpisow.get(plik.nazwaPliku);
      return {
        ...plik,
        opis: opis?.opis ?? null,
        opisAlt: opis?.opisAlt ?? null,
      };
    });
  }


  /**
   * Funkcja wyświetla kolejne zdjęcie
   */
  nastepneZdjecie() {
    if (this.obrazkiIWideo && this.obrazkiIWideo.pliki?.length > 0) {
      this.wybraneZdjecieIndeks = this.znajdzKolejnyIndex(this.wybraneZdjecieIndeks);
      this.wybraneZdjecie = this.obrazkiIWideo.pliki[this.wybraneZdjecieIndeks];
      this.ustawMiniaturki();
    }
  }

  /**
   * Funkcja wyświetla kolejne audio
   */
  nastepneAudio() {
    if (this.dzwieki && this.dzwieki.pliki?.length > 0) {
      this.wybraneAudioIndeks = this.znajdzKolejnyAudioIndex(this.wybraneAudioIndeks);
      this.wybraneAudio = this.dzwieki.pliki[this.wybraneAudioIndeks];
      this.ustawMiniaturki();
    }
  }

  /**
   * Funkcja wyświetla poprzednie zdjęcie
   */
  poprzednieZdjecie() {
    if (this.obrazkiIWideo && this.obrazkiIWideo.pliki?.length > 0) {
      this.wybraneZdjecieIndeks = this.znajdzPoprzedniIndex(this.wybraneZdjecieIndeks);
      this.wybraneZdjecie = this.obrazkiIWideo.pliki[this.wybraneZdjecieIndeks];
      this.ustawMiniaturki();
    }
  }

  /**
   * Funkcja wyświetla poprzednie zdjęcie
   */
  poprzednieAudio() {
    if (this.dzwieki && this.dzwieki.pliki?.length > 0) {
      this.wybraneAudioIndeks = this.znajdzPoprzedniAudioIndex(this.wybraneAudioIndeks);
      this.wybraneAudio = this.dzwieki.pliki[this.wybraneAudioIndeks];
      this.ustawMiniaturki();
    }
  }

  /**
    * Funckaj ustawia zdjęcie po kliknięciu
    * @param index
    */
  ustawZdjecie(index: number) {
    if (this.obrazkiIWideo && this.obrazkiIWideo.pliki?.length > 0) {
      this.wybraneZdjecieIndeks = index;
      this.wybraneZdjecie = this.obrazkiIWideo.pliki[index];
    }
  }

  /**
      * Funckaj ustawia audio po kliknięciu
      * @param index
      */
  ustawAudio(index: number) {
    if (this.dzwieki && this.dzwieki.pliki?.length > 0) {
      this.wybraneAudioIndeks = index;
      this.wybraneAudio = this.dzwieki.pliki[index];
    }
  }

  /**
   * Funkcja ustala kolejny index obrazka
   * @param index
   */
  private znajdzKolejnyIndex(index: number): number {
    if (this.obrazkiIWideo && this.obrazkiIWideo.pliki.length > 0) {
      const nastepnyIndex = index + 1;
      if (nastepnyIndex > this.obrazkiIWideo.pliki.length - 1) {
        return 0;
      }
      return nastepnyIndex;
    }
    return 0;
  }

  /**
    * Funkcja ustala kolejny index audio
    * @param index
    */
  private znajdzKolejnyAudioIndex(index: number): number {
    if (this.dzwieki && this.dzwieki.pliki.length > 0) {
      const nastepnyIndex = index + 1;
      if (nastepnyIndex > this.dzwieki.pliki.length - 1) {
        return 0;
      }
      return nastepnyIndex;
    }
    return 0;
  }

  /**
   * Znajdowanie indeksu obrazkow dlakaruzeli obrazkow
   * @param index
   */
  private znajdzIndexDlaKaruzeli(index: number): number {
    if (!this.obrazkiIWideo || this.obrazkiIWideo.pliki.length === 0) {
      return 0;
    }
    if (index > this.obrazkiIWideo.pliki.length - 1) {
      return index - this.obrazkiIWideo.pliki.length;
    }
    return index;
  }

  /**
    * Znajdowanie indeksu obrazkow dlakaruzeli obrazkow
    * @param index
    */
  private znajdzIndexDlaKaruzeliAudio(index: number): number {
    if (!this.dzwieki || this.dzwieki.pliki.length === 0) {
      return 0;
    }
    if (index > this.dzwieki.pliki.length - 1) {
      return index - this.dzwieki.pliki.length;
    }
    return index;
  }

  /**
   * Funkcja ustala poprzedni index obrazka
   * @param index
   */
  private znajdzPoprzedniIndex(index: number) {
    if (this.obrazkiIWideo && this.obrazkiIWideo.pliki.length > 0) {
      const nastepnyIndex = index - 1;
      if (nastepnyIndex < 0) {
        return this.obrazkiIWideo.pliki.length - 1;
      }
      return nastepnyIndex;
    }
    return 0;
  }

  /**
    * Funkcja ustala poprzedni index audio
    * @param index
    */
  private znajdzPoprzedniAudioIndex(index: number) {
    if (this.dzwieki && this.dzwieki.pliki.length > 0) {
      const nastepnyIndex = index - 1;
      if (nastepnyIndex < 0) {
        return this.dzwieki.pliki.length - 1;
      }
      return nastepnyIndex;
    }
    return 0;
  }

  /**
   * Pomocnicza funkcja do inicjalizacji karuzeli plików (obrazki/wideo lub audio)
   */
  private inicjujKaruzele(pliki: Plik[], setWybranyIndeks: (v: number) => void, setWybranyPlik: (p: Plik) => void, setPlikiWKaruzeli: (arr: ElementKaruzeli[]) => void, ustawMiniaturki: () => void) {
    setWybranyIndeks(0);
    setWybranyPlik(pliki[0]);
    const karuzela: ElementKaruzeli[] = [];
    if (pliki.length >= 3) {
      karuzela.push({ plik: pliki[0], index: 0 });
      karuzela.push({ plik: pliki[1], index: 1 });
      karuzela.push({ plik: pliki[2], index: 2 });
      setPlikiWKaruzeli(karuzela);
      ustawMiniaturki();
    } else {
      pliki.forEach((p, i) => {
        karuzela.push({ plik: p, index: i });
      });
      setPlikiWKaruzeli(karuzela);
      ustawMiniaturki();
    }
  }

  /**
   * Funkcja inicjuje galerie
   */
  private inicjujGalerie() {
    if (this.multimedia && this.multimedia.pliki.length > 0) {
      this.dzwieki = { pliki: [] };
      this.obrazkiIWideo = { pliki: [] };
      this.multimedia.pliki.forEach((p) => {
        if (p.rozszerzenie && ObiektZalacznikiIZdjeciaComponent.AUDIO_EXT.has(p.rozszerzenie)) {
          this.dzwieki.pliki.push(p);
        } else if (p.rozszerzenie && ObiektZalacznikiIZdjeciaComponent.VIDEO_EXT.has(p.rozszerzenie)) {
          this.obrazkiIWideo.pliki.push(p);
          p.sciezkaMiniaturki = 'assets/images/wideo.png';
        } else if (p.rozszerzenie && ObiektZalacznikiIZdjeciaComponent.IMAGE_EXT.has(p.rozszerzenie)) {
          this.obrazkiIWideo.pliki.push(p);
        }
      });
    }

    if (this.obrazkiIWideo && this.obrazkiIWideo.pliki?.length > 0) {
      this.inicjujKaruzele(
        this.obrazkiIWideo.pliki,
        v => this.wybraneZdjecieIndeks = v,
        p => this.wybraneZdjecie = p,
        arr => this.plikiWKaruzeli = arr,
        () => this.ustawMiniaturki()
      );
    }

    if (this.dzwieki && this.dzwieki.pliki?.length > 0) {
      this.inicjujKaruzele(
        this.dzwieki.pliki,
        v => this.wybraneAudioIndeks = v,
        p => this.wybraneAudio = p,
        arr => this.plikiWKaruzeliAudio = arr,
        () => this.ustawMiniaturkiAudio()
      );
    }
  }

  /**
 * Funkcja ustawia obrazki w galerii
 */
  private ustawMiniaturki() {
    if (this.obrazkiIWideo && this.obrazkiIWideo.pliki?.length > 0) {
      this.plikiWKaruzeli?.forEach((p, i) => {
        p.index = this.znajdzIndexDlaKaruzeli(this.wybraneZdjecieIndeks + i);
        p.plik = this.obrazkiIWideo!.pliki[p.index];
        if (p.plik.rozszerzenie && (['mp4', 'ogv', 'webm', 'm4v'].indexOf(p.plik.rozszerzenie) > -1)) {
          p.plik.sciezkaMiniaturki = 'assets/images/wideo.png'
        };
        if (p.plik.rozszerzenie && (['apng', 'avif', 'gif', 'jpg', 'jpeg', 'jfif', 'pjpeg', 'pjp', 'png', 'svg', 'webp', 'tif', 'tiff'].indexOf(p.plik.rozszerzenie) > -1)) {
          if (!p.plik.sciezkaMiniaturki) { p.plik.sciezkaMiniaturki = new HttpUrlEncodingCodec().encodeValue(this.url + p.plik.sciezka) };
        };
      });
    }
  }

  /**
   * Funkcja ustawia obrazki w galerii audio
   */
  private ustawMiniaturkiAudio() {
    if (this.dzwieki && this.dzwieki.pliki?.length > 0) {
      this.plikiWKaruzeliAudio?.forEach((p, i) => {
        p.index = this.znajdzIndexDlaKaruzeliAudio(this.wybraneAudioIndeks + i);
        p.plik = this.dzwieki!.pliki[p.index];
        p.plik.sciezkaMiniaturki = 'assets/images/audio.png';

      });
    }
  }

  /**
   * Funkcja pokazuje pełnoekranowa galerie
   */
  pokazGaleriePelnoekranowa() {
    this.widocznaGaleriaPelnoekranowa = true;
  }

  /**
   * Funkcja zamyka pełnoekranowa galerie
   */
  zamknijGaleriePelnoekranowa() {
    this.widocznaGaleriaPelnoekranowa = false;
  }

  /**
   * Funkcja czyści dane
   */
  wyczyscDane() {
    this.wybraneZdjecie = undefined;
    this.wybraneAudio = undefined;
    this.wybraneZdjecieIndeks = 0;
    this.wybraneAudioIndeks = 0;
    if (this.plikiWKaruzeli) this.plikiWKaruzeli.length = 0;
    if (this.plikiWKaruzeliAudio) this.plikiWKaruzeliAudio.length = 0;
    this.multimedia = undefined;
    if (this.obrazkiIWideo && this.obrazkiIWideo.pliki) this.obrazkiIWideo.pliki.length = 0;
    if (this.dzwieki && this.dzwieki.pliki) this.dzwieki.pliki.length = 0;
    this.zalaczniki = undefined;
    if (this.zalacznikiOpisy) this.zalacznikiOpisy.length = 0;
  }

  private static readonly AUDIO_EXT = new Set(['mp3', 'ogg', 'wav', 'flac']);
  private static readonly VIDEO_EXT = new Set(['mp4', 'ogv', 'webm', 'm4v']);
  private static readonly IMAGE_EXT = new Set(['apng', 'avif', 'gif', 'jpg', 'jpeg', 'jfif', 'pjpeg', 'pjp', 'png', 'svg', 'webp', 'tif', 'tiff']);
}
